import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  SecretariaMember,
  SecretariaPermissionGroup,
} from '../../types/secretariaPermissions';
import { secretariaPermissionsService } from './services';

const mensagem = (error: unknown, fallback: string) =>
  error instanceof Error && error.message ? error.message : fallback;

export const fetchSecretariaPermissionsPanel = createAsyncThunk<
  { groups: SecretariaPermissionGroup[]; members: SecretariaMember[] },
  void,
  { rejectValue: string }
>('secretariaPermissions/fetchPanel', async (_, { rejectWithValue }) => {
  try {
    const [groups, members] = await Promise.all([
      secretariaPermissionsService.fetchCatalogo(),
      secretariaPermissionsService.fetchMembros(),
    ]);
    return { groups, members };
  } catch (error) {
    return rejectWithValue(mensagem(error, 'Erro ao carregar usuários e permissões'));
  }
});

export const fetchSecretariaMemberPermissions = createAsyncThunk<
  { memberId: string; permissions: string[] },
  string,
  { rejectValue: string }
>('secretariaPermissions/fetchMember', async (memberId, { rejectWithValue }) => {
  try {
    const permissions = await secretariaPermissionsService.fetchPermissoes(memberId);
    return { memberId, permissions };
  } catch (error) {
    return rejectWithValue(mensagem(error, 'Erro ao carregar as permissões do usuário'));
  }
});

export const saveSecretariaMemberPermissions = createAsyncThunk<
  { memberId: string; permissions: string[] },
  { memberId: string; permissions: string[] },
  { rejectValue: string }
>('secretariaPermissions/save', async ({ memberId, permissions }, { rejectWithValue }) => {
  try {
    const salvas = await secretariaPermissionsService.salvarPermissoes(memberId, permissions);
    return { memberId, permissions: salvas };
  } catch (error) {
    return rejectWithValue(mensagem(error, 'Erro ao salvar as alterações'));
  }
});

export const removeSecretariaMember = createAsyncThunk<string, string, { rejectValue: string }>(
  'secretariaPermissions/remove',
  async (memberId, { rejectWithValue }) => {
    try {
      await secretariaPermissionsService.removerMembro(memberId);
      return memberId;
    } catch (error) {
      return rejectWithValue(mensagem(error, 'Erro ao remover o usuário'));
    }
  },
);
